import * as React from 'react';

import StickyContentDesktop from 'bundles/coursera-plus-landing-page/components/stickyBannerContentful/StickyContentDesktop';
import StickyContentMobile from 'bundles/coursera-plus-landing-page/components/stickyBannerContentful/StickyContentMobile';
import StickyBanner from 'bundles/design-system/components/StickyBanner';

type Props = {
  bannerText?: string | null;
  children: React.ReactNode;
};

class StickyBannerContentful extends React.Component<Props> {
  declare childRef: HTMLElement | null;

  declare bannerText: string;

  constructor(props: $TSFixMe) {
    super(props);
    this.childRef = null;
    this.bannerText = props.bannerText ?? '';
  }

  shouldShowStickyBanner = (): boolean => {
    if (!this.childRef) {
      return false;
    }
    return this.childRef.getBoundingClientRect().bottom <= 0;
  };

  render() {
    const { children } = this.props;
    return (
      <div>
        <div
          ref={(el) => {
            this.childRef = el;
          }}
        >
          {children}
        </div>
        <StickyBanner shouldShowStickyBanner={this.shouldShowStickyBanner}>
          {(isMobile) => (isMobile ? <StickyContentMobile /> : <StickyContentDesktop bannerText={this.bannerText} />)}
        </StickyBanner>
      </div>
    );
  }
}

export default StickyBannerContentful;
